import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import WarningAmber from '@mui/icons-material/WarningAmber';
import { Box, Typography } from '@mui/material';
import { useFormikContext } from 'formik';

import type { SurveyDetailUpdate } from 'src/types/survey';

import { styles } from 'src/components/survey/SurveySettings/index.styles';

const EditRootCauseWarning: FC = () => {
  const { t } = useTranslation('survey');
  const { values, initialValues } = useFormikContext<SurveyDetailUpdate>();
  const showWarning = initialValues.specificSettings.followUp.rootCauses.some(
    (initialRootCause) =>
      values.specificSettings.followUp.rootCauses.find(
        (editedRootCause) =>
          editedRootCause.id === initialRootCause.id &&
          editedRootCause.name !== initialRootCause.name,
      ),
  );
  return showWarning ? (
    <Box sx={styles.rootCauseEditWarning}>
      <WarningAmber color="primary" />
      <Typography color="primary" variant="caption2">
        {t('settings.followUpModule.warning')}
      </Typography>
    </Box>
  ) : null;
};

export default EditRootCauseWarning;
